export const util = {
  /**
   * Creates deep copy of conversationEntries for searching.
   */
  createDeepCopy<T>(conversationEntries: T): T {
    return JSON.parse(JSON.stringify(conversationEntries)) as T;
  },

  /**
   * Generates a full style formatted date and time (e.g. 01/01/2024, 10:00:00 AM).
   */
  formatDateTime(timestamp: number) {
    return new Intl.DateTimeFormat('en-US', {
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      month: '2-digit',
      second: '2-digit',
      year: 'numeric',
    }).format(timestamp);
  },

  getFormattedDate(timestamp: number) {
    const formattedDateTime = this.formatDateTime(timestamp);

    return formattedDateTime.split(',')[0]?.trim() || '';
  },

  getFormattedTime(timestamp: number) {
    const formattedDateTime = this.formatDateTime(timestamp);

    return formattedDateTime.split(',')[1]?.trim() || '';
  },
};
